export default class OrderPurchasePendingSockets {
  constructor() {
    this._result = new Promise((resolve) => {
      this._onPaymentSucceed = () => resolve();
    });
  }

  destroy() {
    const destroyed = this._purchaseSocketsDestructor && this._purchaseSocketsDestructor();
    this._purchaseSocketsDestructor = undefined;
    return destroyed;
  }

  run() {
    this._initializeSockets();
    return this._result;
  }

  _initializeSockets() {
    this._socketListenerBuilder((res) => {
      if (res.url && res.url !== "") {
        this._onPaymentSucceed();
        window.location.href = res.url;
      }
    });
    return this;
  }

  _socketListenerBuilder(fn) {
    $("body").on("tc-purchase-processed", fn.bind(this));
    this._purchaseSocketsDestructor = () => {
      $("body").off("tc-purchase-processed", fn.bind(this));
      return true;
    };
  }
}
